module.exports = __webpack_public_path__ + "static/media/s1.6060b290.png";